import { useState, useEffect } from 'react';
import { fetchAuthSession } from 'aws-amplify/auth';
import { AdminContext } from '../types/admin';

export function useAdminAccess(): AdminContext {
  const [context, setContext] = useState<AdminContext>({
    isAdmin: false,
    isSuperAdmin: false,
    isTenantAdmin: false,
    loading: true,
    groups: []
  });

  useEffect(() => {
    async function checkAccess() {
      try {
        const session = await fetchAuthSession();
        const payload = session.tokens?.idToken?.payload;
        const groups = (payload?.['cognito:groups'] as string[]) || [];

        const isSuperAdmin = groups.includes('SuperAdmin');
        const isTenantAdmin = groups.includes('TenantAdmin');
        const isAdmin = isSuperAdmin || isTenantAdmin;

        setContext({
          isAdmin,
          isSuperAdmin,
          isTenantAdmin,
          loading: false,
          groups
        });
      } catch (e) {
        console.error('Failed to check admin access:', e);
        setContext(prev => ({ ...prev, loading: false }));
      }
    }

    checkAccess();
  }, []);

  return context;
}
